import styles from "./authFooter.module.scss";
export default function AuthFooter() {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.app_version}>1.0.0</div>
        <div className={styles.ball_gradient_footer}></div>
      </div>
    </>
  );
}
